export default __webpack_public_path__ + "6d1df972dfc8da1eb583643fa6b8cec6.png";